export default "__VITE_ASSET__fXOtuFNG__"